/** TASK-849 — Active Plans copy. The shop does the advertising and the forward. */

export const VOICE_REACH_ADVERTISE = 'advertise';
export const VOICE_REACH_FORWARD = 'forward';

export const voiceReachIntro =
  'Customers reach this Voice number in one of two ways. You make the change on Google, your website, or your phone company.';

export const voiceReachAdvertiseHelp =
  'Put this number on Google and on your website. Autoshops does not change those for you.';

export const voiceReachForwardHelp =
  'Keep your existing customer number as the one people call. Forward that number to this Voice number. You do this on your phone company or on your office phone system.';

export const voiceReachCarrierTitle = 'Phone company';

export const voiceReachCarrierSteps = [
  'Sign in to the account that owns your existing shop number.',
  'Open call forwarding for that number.',
  'Forward all calls to the Voice number shown above.',
  'Save, then call your existing number from another phone and confirm the assistant answers.',
];

export const voiceReachPbxTitle = 'Office phone system';

export const voiceReachPbxSteps = [
  'Sign in to the phone system that rings your existing shop number.',
  'Open the main number.',
  'Forward that number to the Voice number shown above.',
  'Save, then call your existing number from another phone and confirm the assistant answers.',
];

export const voiceReachForwardNote =
  'We do not log in and do this for you. This does not move your old number onto our phone system. Texts to your old number are not forwarded. A press-1 menu stays on your own phone system if you already have one.';

export const voiceReachKeepNumber =
  'This shop has no public phone number on file. You keep the Voice number we set up. Put that number on Google and on your website when you advertise. There is no existing number to forward.';

export const voiceReachPending =
  'Your Voice number is still being set up. You can choose how customers reach it once the number appears here.';
